import { JsonObject } from '../../helpers';
import { ClassifierModel, ClassifierSubType, ClassifierType } from './classifier.model';

export class IntentClassifierModel extends ClassifierModel {
  phrases: string[];
  numSyntheticConversations: number;

  constructor(props: JsonObject = {}) {
    super(props);

    this.phrases = (props.phrases as string[]) || [];
    this.numSyntheticConversations = (props.numSyntheticConversations as number) || 0;

    if (!this.type) {
      this.type = ClassifierType.Custom;
    }
    if (!this.subtype) {
      this.subtype = ClassifierSubType.Custom;
    }
  }
}
